import {
  ACCOUNT_DELETED,
  AUTH_ERROR,
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  LOGOUT,
  REGISTER_FAIL,
  REGISTER_SUCCESS,
  USER_LOADED,
} from "../actions/types";

const initialState = {
  token: localStorage.getItem("token"),
  username: localStorage.getItem("username"),
  isAuthenticated: null,
  loading: localStorage.getItem("username") === null || "" ? false : true,
  user: null,
};

export default function auth(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case USER_LOADED:
    case REGISTER_SUCCESS:
    case LOGIN_SUCCESS:
      localStorage.setItem("token", payload?.accessToken);
      localStorage.setItem("username", payload?.displayName);
      localStorage.setItem("email", payload?.email);
      localStorage.setItem("uid", payload?.uid);
      return {
        ...state,
        username: payload?.displayName,
        email: payload?.email,
        token: payload?.accessToken,
        uid: payload?.uid,
        isAuthenticated: true,
        loading: false,
      };
    case REGISTER_FAIL:
    case AUTH_ERROR:
    case LOGIN_FAIL:
    case ACCOUNT_DELETED:
      localStorage.removeItem("token");
      return {
        ...state,
        isAuthenticated: false,
        loading: false,
        token: null,
        loginFailed: true,
      };
    case LOGOUT:
      localStorage.removeItem("token");
      localStorage.removeItem("username");
      localStorage.removeItem("email");
      return {
        ...state,
        isAuthenticated: false,
        loading: false,
        token: null,
        username: null,
        email: null,
      };
    default:
      return state;
  }
}
